import "./style.less"

const PageLayout: React.FunctionComponent<{ children: React.ReactNode }> = ({ children }) => {
    return (
        <div
            id="pagelayout"
            className={`pagelayout${window.location.pathname.includes("cashier") ? " cashierPageLayout" : ""}`}
        >
            {children}
        </div>
    )
}

export default PageLayout
